import { render, staticRenderFns } from "./HomeFactory.vue?vue&type=template&id=3e8f4026&scoped=true&"
import script from "./HomeFactory.vue?vue&type=script&lang=js&"
export * from "./HomeFactory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8f4026",
  null
  
)

export default component.exports